import { whatsAppLink } from "../config/commonConfig";

const WhatsAppButton  = ({ text = "SOLICITE SEU ATENDIMENTO" }) => {

  return (
    <div className="d-inline-flex bg-white shadow rounded botao-wp"
    style={{ textDecoration: "none", backgroundColor: '#33D621', background: 'linear-gradient(180deg,rgba(51, 214, 33, 1) 0%, #26a219 100%)' }}
    >
      <a
        className="p-1 d-flex flex-wrap align-items-center align-content-center shadow rounded "
        href={whatsAppLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="img-fluid"
          src="images/whatsapp.png"
          alt=""
        /> {" "} <span className="ms-3 me-3 text-white">{text}</span>
      </a>
    </div>
  )
};

export default WhatsAppButton;